export default class ValoresPagamentos {

  constructor(data) {
    this.vlrAguardandoPagamento = data.vlrAguardandoPagamento;
    this.vlrBloqueado = data.vlrBloqueado;
    this.vlrLiquidado = data.vlrLiquidado;
  }

}



// WEBPACK FOOTER //
// ./src/custom/abbrasil/spa/dashboard/cadeia/pagamento/ValoresPagamentos.js